<template>
  <div id="main-content" class="feature-landing-page">
    <h1>Snap and send submission successful</h1>

    <p>Your snap and send claim has been submitted for processing.</p>
    <router-link :to="{ name: SNAP_AND_SEND }" class="button primary">Make another claim</router-link>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { VUEX_GENERAL } from '@/constants/VuexConstants';
import { SNAP_AND_SEND, ERROR_404_PAGE_NOT_FOUND } from '@/router/routeNames';

export default {
  name: 'SnapAndSendSubmission',

  data() {
    return {
      SNAP_AND_SEND,
      navState: window.history.state || {},
    };
  },

  computed: {
    ...mapGetters({
      policyNumber: VUEX_GENERAL.GETTERS.getCurrentPolicyNumber,
      currentIsExtrasFlag: VUEX_GENERAL.GETTERS.getCurrentPolicyIsExtrasFlag,
    }),
  },

  beforeMount() {
    if (!this.navState?.refData) {
      this.$router.push({ name: ERROR_404_PAGE_NOT_FOUND });
    }
  },
};
</script>

<style lang="scss" scoped>
#main-content {
  p {
    margin-bottom: 2.5em;
  }
}
</style>
